import { COLUMN_TYPES_ENUM, TIME_TYPE_COLUMNS } from 'modules/report/enums/columnTypeEnum';
import * as columnUnitTypes from 'modules/report/enums/columnUnitTypeEnum';
import { displayDateState } from 'modules/report/utils/columnHelper';

/**
 * @returns {*[]}
 */
export default dateState => [
    {
        id: 'scheduledTimeBetween',
        display: displayDateState(dateState, false, false),
        displayTimeType: 'Scheduled Time',
        displayColumnType: 'time',
        unitType: columnUnitTypes.TIME.value,
        columnType: COLUMN_TYPES_ENUM.TIME,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: true,
    },
    {
        id: 'scheduledTimeToDate',
        display: 'To Date',
        displayTimeType: 'Scheduled Time',
        displayColumnType: 'time',
        unitType: columnUnitTypes.TIME.value,
        columnType: COLUMN_TYPES_ENUM.TIME,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: false,
    },
    {
        id: 'scheduledTimeFuture',
        display: 'Future',
        displayTimeType: 'Scheduled Time',
        displayColumnType: 'time',
        unitType: columnUnitTypes.TIME.value,
        columnType: COLUMN_TYPES_ENUM.TIME,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: false,
    },
    {
        id: 'scheduledTimeAllTime',
        display: 'All Time',
        displayTimeType: 'Scheduled Time',
        displayColumnType: 'time',
        unitType: columnUnitTypes.TIME.value,
        columnType: COLUMN_TYPES_ENUM.TIME,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: false,
    },
    {
        id: 'billableScheduledTimeBetween',
        display: displayDateState(dateState, false, false),
        displayTimeType: 'Scheduled Time (Billable)',
        displayColumnType: 'time',
        unitType: columnUnitTypes.TIME.value,
        columnType: COLUMN_TYPES_ENUM.TIME,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: true,
    },
    {
        id: 'billableScheduledTimeToDate',
        display: 'To Date',
        displayTimeType: 'Scheduled Time (Billable)',
        displayColumnType: 'time',
        unitType: columnUnitTypes.TIME.value,
        columnType: COLUMN_TYPES_ENUM.TIME,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: false,
    },
    {
        id: 'billableScheduledTimeFuture',
        display: 'Future',
        displayTimeType: 'Scheduled Time (Billable)',
        displayColumnType: 'time',
        unitType: columnUnitTypes.TIME.value,
        columnType: COLUMN_TYPES_ENUM.TIME,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: false,
    },
    {
        id: 'billableScheduledTimeAllTime',
        display: 'All Time',
        displayTimeType: 'Scheduled Time (Billable)',
        displayColumnType: 'time',
        unitType: columnUnitTypes.TIME.value,
        columnType: COLUMN_TYPES_ENUM.TIME,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: false,
    },
    {
        id: 'nonBillableScheduledTimeBetween',
        display: displayDateState(dateState, false, false),
        displayTimeType: 'Scheduled Time (Non-Billable)',
        displayColumnType: 'time',
        unitType: columnUnitTypes.TIME.value,
        columnType: COLUMN_TYPES_ENUM.TIME,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: true,
    },
    {
        id: 'nonBillableScheduledTimeToDate',
        display: 'To Date',
        displayTimeType: 'Scheduled Time (Non-Billable)',
        displayColumnType: 'time',
        unitType: columnUnitTypes.TIME.value,
        columnType: COLUMN_TYPES_ENUM.TIME,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: false,
    },
    {
        id: 'nonBillableScheduledTimeFuture',
        display: 'Future',
        displayTimeType: 'Scheduled Time (Non-Billable)',
        displayColumnType: 'time',
        unitType: columnUnitTypes.TIME.value,
        columnType: COLUMN_TYPES_ENUM.TIME,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: false,
    },
    {
        id: 'nonBillableScheduledTimeAllTime',
        display: 'All Time',
        displayTimeType: 'Scheduled Time (Non-Billable)',
        displayColumnType: 'time',
        unitType: columnUnitTypes.TIME.value,
        columnType: COLUMN_TYPES_ENUM.TIME,
        timeType: TIME_TYPE_COLUMNS.SCHEDULED,
        heatMapSupport: false,
    },
];
